import { jobOrderRequest } from '@/network/requests/jobOrder'

import { FilterQuery } from '@/network/interfaces/FilterQuery'
import { getDefectStatisByJobOrderId, defectStatisRequest, groupDefectStatisListByJobOrderId, queryAllDefectStatisListByJobOrderIdList } from '@/network/requests/defectStatis'
import { formatDate } from '@/util/datetime'
import { processGroupRequest } from '@/network/requests/processGroup'
import { processGroupDetailRequest, getProcessGroupDetails, getProcessGroupDetailsByGroupIdArray } from '@/network/requests/processGroupDetail'
import { processInfoRequest } from '@/network/requests/processInfo'
import { process_Info } from '@/interfaces/process_Info'
import jtInfo, { jtInfoRequest } from '@/network/requests/jtInfo'
import { jt_info } from '@/interfaces/jt_info'
import { workshop } from '@/interfaces/workshop'
import { workshopRequest } from '@/network/requests/workshop'
import { seriousDefectRequest } from '@/network/requests/seriousDefect'
import { serious_defect } from '@/interfaces/serious_defect'
import { job_order } from '@/interfaces/job_order'
import { jt_status } from '@/interfaces/jt_status'
import jtService from './jtService'
import { defect_statis } from '@/interfaces/defect_statis'
import { productRequest } from '@/network/requests/product'
import defectService from './defectService'
import { getDefectRequest, getDefectTypeGroup } from '@/network/requests/defect'
import { defectTypeRequest } from '@/network/requests/defectType'
import { getRandomId } from '@/util/UUID'
import { product } from '@/interfaces/product'
import { like, $in } from '@/network/util/QueryBuilder'
import { groupBy } from 'lodash'
import { restHeartClient } from '@/network'
import { jtStatusRequest } from '@/network/requests/jtStatus'
import { defect_xxx } from '@/interfaces/defect_xxx'
import { defect_type } from '@/interfaces/defect_type'
import { realBatchInfoRequest } from '@/network/requests/realBatchInfo'
import { sliceArray } from '@/util/sliceArray'

var jobOrderStatus: any = {
	0: { text: '空' },
	1: { text: '准备' },
	2: { text: '印刷' },
	3: { text: '复合' },
	4: { text: '分切' },
	5: { text: '复卷' },
}

interface jobOrderDefectStatis {
	id: string
	index: string | undefined
	productName?: string | undefined
	jtName?: string
	workCode: string
	batchCode?: string | undefined
	/**
	 * 批次状态。
	 */
	batchStatus: string
	/**
	 * 坏品张数。
	 */
	badCount: number
	/**
	 * 筛选状态。
	 */
	filterStatus: string
	/**
	 *
	 */

	inspCount: number
	totalBadCount: number
	totalDefCount: number
	totalLength: number
	children?: jobOrderDefectStatis[] | undefined
	target?: string | undefined
	filter_time: string | undefined
	beginTime?: string | undefined
	endTime?: string | undefined
	label?: string | undefined
	filterTime?: string | undefined
}

var getJobOrderStatusText = (val?: number) => {
	if (val) {
		if (jobOrderStatus[val]) {
			return jobOrderStatus[val].text
		}
	}

	return jobOrderStatus[0].text
}

/**
 * 根据批次列表计算该这些批次的统计指标: adjustLength, inspCount, badCount, yieldRate
 * @param defectStatisList 批次列表
 */
const getTotalStatisticsOfDefectStatisList = (defectStatisList: defect_statis[]) => {
	var adjustLength = 0 //调机米数。
	var inspCount = 0 //检测总张数。
	var badCount = 0 //坏品数。
	for (var defectItem of defectStatisList) {
		if (defectItem.is_adjust) {
			adjustLength += defectItem.total_len!
		}

		inspCount += defectItem.Insp_count!
		badCount += defectItem.bad_count!
	}
	//良品率。
	var yieldRate = 0
	if (inspCount > 0) {
		yieldRate = Math.abs(1 - badCount / inspCount)
	}

	console.log('yieldRate', yieldRate)
	return { adjustLength, inspCount, badCount, yieldRate }
}

/**
 *
 * @param jobOrder
 * @param jtList
 * @param workshops
 * @param jtStatusList
 */
var getJobOrderStatusAsync2 = async (jobOrder: job_order, jtList: jt_info[], workshops: workshop[], jtStatusList: jt_status[]) => {
	var v = jobOrder
	//根据工单号获取批次记录。
	var defectData = await getDefectStatisByJobOrderId(v._id?.$oid)

	//调机米数。
	var adjustLength = 0
	//检测总张数。
	var inspCount = 0
	//坏品张数。
	var badCount = 0
	var unprocess_serious_defect_count = 0
	for (var defectItem of defectData) {
		if (defectItem.is_adjust) {
			adjustLength += defectItem.total_len!
		}

		inspCount += defectItem.Insp_count!
		badCount += defectItem.bad_count!
	}

	var defect_ids = defectData.map(t => t._id?.$oid)
	//严重废。
	var seriousDefects: serious_defect[] = await seriousDefectRequest.queryAll({ roll_id: $in(defect_ids), process_result: 0 }, { process_result: 1 }, undefined, 1000)
	unprocess_serious_defect_count += seriousDefects.length

	//良品率。
	var yieldRate = 0
	if (inspCount > 0) {
		yieldRate = Math.abs(1 - badCount / inspCount)
	}

	//机台信息。
	var jtInfo: jt_info = {}
	var jtStatus: jt_status = {}
	if (v.jt_id) {
		jtInfo = jtList.find(t => t._id?.$oid == v.jt_id) ?? {} // await (await jtInfoRequest.getDocumentById(v.jt_id)).data
		jtStatus = jtStatusList.find(t => t.jt_id == v.jt_id) ?? {} // await jtService.getJTStatusInfo(v.jt_id)
	}

	var workshop: workshop | undefined = {}

	if (jtInfo.workshop_id) {
		//车间信息。
		workshop = workshops.find(t => t._id?.$oid == jtInfo.workshop_id) // await (await workshopRequest.getDocumentById(jtInfo.workshop_id)).data
	}

	// for (var sd of seriousDefects) {
	// 	if (!sd.process_result) {
	// 		unprocess_serious_defect_count += 1
	// 	}
	// }

	//当前工序。
	var process_list: process_Info[] = []
	if (v.process_group_id) {
		var process_details = await getProcessGroupDetails(v.process_group_id)
		for (var pd of process_details) {
			var process_info = (await processInfoRequest.getDocumentById(pd.process_id!)).data
			process_info.sequence = pd.sequence
			process_list.push(process_info)
		}
	}

	//下一工序。
	var next_process: string | undefined = ''
	if (process_list.length > 0) {
		next_process = process_list[0].name
	}

	var current_process = (process_list[0] && process_list[0].name) || ''

	var process_str = process_list.map(p => p.name).join(',')
	//机台状态。
	var jt_status_str = jtService.getJTStatusText(jtStatus)

	console.log('adjustLength', adjustLength)
	console.log('badCount', badCount)
	console.log('inspCount', inspCount)
	console.log('yieldRate', yieldRate)

	return {
		...v,
		adjustLength,
		yieldRate: (yieldRate * 100).toFixed(2),
		process_list,
		process_str,
		jt_status_str,
		jtInfo,
		unprocess_serious_defect_count,
		workshop_name: workshop?.name,
		next_process: next_process,
		current_process: current_process,
		start_time_str: formatDate(v.start_time!),
		end_time_str: formatDate(v.end_time!),
	}
}

const getStatusOfJobOrderList = async (jobOrderList: job_order[]) => {
	const jobOrderIdList = jobOrderList.map(jobOrder => jobOrder._id!.$oid)
	// 全部工序组 id
	const processGroupIdList = jobOrderList.map(jobOrder => jobOrder.process_group_id).filter(i => i !== undefined)
	// 全部机台 id
	const jtIdList = jobOrderList.map(jobOrder => jobOrder.jt_id!).filter(i => i !== undefined)
	// 并发以下请求
	// 请求1： 根据全部机台id，获取它们对应的 jtInfo
	const p1 = jtInfoRequest.queryIdMapByIds(jtIdList)
	// 请求2：根据全部 jtInfo ，获取相关联的车间信息
	const p2 = p1.then(jtIdToJtInfoMap => {
		const jtInfoList = [...jtIdToJtInfoMap.values()]
		return workshopRequest.queryIdMapByIds(jtInfoList.map(jtInfo => jtInfo.workshop_id!).filter(i => i !== undefined))
	})
	// 请求3： 根据 jobOrderIdList 获取 每个 jobOrderId 对应的 defectStatisList
	const p3 = queryAllDefectStatisListByJobOrderIdList(jobOrderIdList).then(allDefectStatisList => groupDefectStatisListByJobOrderId(allDefectStatisList))
	// 请求4： 根据全部工序组id，获取一个 工序组 id 为 key，工序组对应的工序列表为 value 的对象
	const p4 = (async processGroupIdList => {
		// 全部工序组详情对象
		const allProcessGroupDetailList = await processGroupDetailRequest.queryAll({
			process_group_id: { $in: processGroupIdList },
		})
		// 全部的工序
		const processIdToProcessInfoMap = await processInfoRequest.queryIdMapByIds(allProcessGroupDetailList.map(processGroupDetail => processGroupDetail.process_id!).filter(i => i !== undefined))
		// 对工序组id和工序进行关联匹配，然后按照工序组进行分组，键是工序组id，值是关联对象
		return allProcessGroupDetailList.reduce((acc, curr) => {
			const process_group_id = curr.process_group_id
			if (process_group_id === undefined) {
				return acc
			}
			if (acc[process_group_id] === undefined) {
				acc[process_group_id] = []
			}
			acc[process_group_id].push(processIdToProcessInfoMap.get(process_group_id))
			return acc
		}, {})
	})(processGroupIdList)
	// 请求5 根据全部机台id，获取它们对应的 jtStatus
	const p5 = jtStatusRequest
		.queryAll({
			jt_id: { $in: jtIdList },
		})
		.then(allJtStatusList => groupBy(allJtStatusList, 'jt_id'))
	// 请求6 根据全部机台id，获取它们对应的严重废列表
	const p6 = seriousDefectRequest.queryAll({ jt_id: { $in: jtIdList }, process_result: 0 }, { jt_id: 1, process_result: 1 }, undefined, 1000).then(allSeriousDefects => groupBy(allSeriousDefects, 'jt_id'))

	const [jtIdToJtInfoMap, workshopIdToWorkshopMap, jobOrderIdDefectStatisListMap, processGroupIdProcessGroupDetailDict, jtIdToJtStautsDict, jtIdToSeriousDefectListDict] = await Promise.all([p1, p2, p3, p4, p5, p6])

	return jobOrderList.map(jobOrder => {
		const { process_group_id, jt_id } = jobOrder
		const jobOrderId = jobOrder._id!.$oid
		const defectStatisList = jobOrderIdDefectStatisListMap[jobOrderId] || []
		const { adjustLength, yieldRate } = getTotalStatisticsOfDefectStatisList(defectStatisList)

		let process_list: process_Info[] = []
		if (process_group_id) {
			process_list = (processGroupIdProcessGroupDetailDict[process_group_id!] || []).filter(i => i !== undefined)
		}
		//下一工序。
		let next_process: string | undefined = ''
		if (process_list.length > 0) {
			next_process = process_list[0].name
		}

		const process_str = process_list.map(p => p.name).join(',')
		const jtInfo = (jt_id && jtIdToJtInfoMap.get(jt_id)) || {}
		const jtStatus = ((jt_id && jtIdToJtStautsDict[jt_id]) || [])[0]
		const jt_status_str = jtService.getJTStatusText(jtStatus || {})
		const workshop_id = jtInfo?.workshop_id
		const workshop = (workshop_id && workshopIdToWorkshopMap.get(workshop_id)) || {}
		const seriousDefectList = (jt_id && jtIdToSeriousDefectListDict[jt_id]) || []

		return {
			...jobOrder,
			adjustLength,
			yieldRate,
			process_list,
			process_str,
			jt_status_str,
			jtInfo,
			unprocess_serious_defect_count: seriousDefectList.filter(seriousDefect => !seriousDefect.process_result).length,
			workshop_name: workshop?.name,
			next_process: next_process,
			current_process: getJobOrderStatusText(jobOrder.status),
			start_time_str: formatDate(jobOrder.start_time!),
			end_time_str: formatDate(jobOrder.end_time!),
			...defectStatisList.reduce(
				(acc, curr) => {
					acc.Insp_count = acc.Insp_count! + curr.Insp_count!
					acc.bad_count = acc.bad_count! + curr.bad_count!
					acc.total_def_count = acc.total_def_count! + curr.total_def_count!
					acc.total_bad_count = acc.total_bad_count! + curr.total_bad_count!
					return acc
				},
				{
					Insp_count: 0,
					bad_count: 0,
					total_def_count: 0,
					total_bad_count: 0,
				}
			),
			children: defectStatisList,
		}
	})
}
/**
 *
 * @param job_order
 */
var getJobOrderStatusAsync = async (job_order: job_order) => {
	//机台信息。
	var jtInfo: jt_info = {}
	var jtStatus: jt_status = {}
	var workshop: workshop = {}
	var product: product = {}
	//当前工序.
	var current_process = ''
	//下一工序。
	var next_process: string | undefined = ''
	var process_str = ''

	//机台信息。
	if (job_order.jt_id) {
		jtInfo = (await jtInfoRequest.getDocumentById(job_order.jt_id!)).data
		jtStatus = await jtService.getJTStatusInfo(job_order.jt_id!)
	}

	//车间信息。
	if (jtInfo.workshop_id) {
		workshop = await (await workshopRequest.getDocumentById(jtInfo.workshop_id)).data
	}

	//产品信息。
	if (job_order.product_id) {
		product = await (await productRequest.getDocumentById(job_order.product_id)).data
	}

	//根据工单号获取批次记录。
	var defectData = await getDefectStatisByJobOrderId(job_order._id?.$oid)
	const { adjustLength, yieldRate } = getTotalStatisticsOfDefectStatisList(defectData)
	var roll_id_array = defectData.map(t => t._id?.$oid)

	//未处理严重废数量。
	var unprocess_serious_defect_count = await (await seriousDefectRequest.getSize({ roll_id: { $in: roll_id_array }, process_result: 0 })).data._size

	//工序处理
	var process_list: any[] = []
	if (product && product.process_group_id) {
		//从产品信息中获取工序组ID。
		var process_group_id = product.process_group_id
		//查询工序组详情。
		var process_details = await getProcessGroupDetails(process_group_id)
		//遍历工序组详情，得到工序集合，然后遍历工序集合。
		for (var pd of process_details) {
			var process_info = (await processInfoRequest.getDocumentById(pd.process_id!)).data
			process_list.push({
				sequence: pd.sequence,
				...process_info,
			})
		}

		if (process_list) {
			//对工序进行排序。
			process_list.sort((a, b) => {
				return a.sequence - b.sequence
			})

			if (job_order.process_index) {
				//这里需要二次转换一下，不然下一工序索引相加的时候，会变成字符串相加。
				var processIndex = parseInt(job_order.process_index.toString())
				if (processIndex > -1) {
					current_process = process_list[processIndex].name

					var nextProcessIndex = processIndex + 1
					if (processIndex >= process_list.length) {
						next_process = '无'
					} else {
						next_process = process_list[nextProcessIndex].name
					}
				}
			}

			process_str = process_list.map(p => p.name).join(',')
		}
	}

	//机台状态。
	var jt_status_str = jtService.getJTStatusText(jtStatus)

	return {
		...job_order,
		adjustLength,
		yieldRate,
		process_list,
		process_str,
		jt_status_str,
		jtInfo,
		unprocess_serious_defect_count,
		workshop_name: workshop?.name,
		next_process: next_process,
		current_process: current_process, //getJobOrderStatusText(job_order.status),
		start_time_str: formatDate(job_order.begin_time!),
		end_time_str: formatDate(job_order.end_time!),
	}
}

/**
 * 获取工单状态。
 * @param job_order_id
 */
var getJobOrderStatusByIdAsync = async (job_order_id: string) => {
	var jobOrder = await (await jobOrderRequest.getDocumentById(job_order_id)).data
	var data = await getJobOrderStatusAsync(jobOrder)

	return data
}
/**
 * 获取工单列表。
 * @param pageIndex
 * @param pageSize
 * @param filter
 */
var getJobOrderList = async (pageIndex: number, pageSize: number, filter: object) => {
	var result = await jobOrderRequest.queryPage({
		page: pageIndex,
		pagesize: pageSize,
		filter: filter,
	})
	// const requests: Promise<any>[] = result.data._embedded.map(async item => {
	// 	try {
	// 		var job_order_id = item._id?.$oid
	// 		var data: { [k: string]: any } = {}
	// 		await Promise.all([
	// 			getJobOrderStatusAsync(item).then((d)=> {
	// 				data = {...d, ...data}
	// 			}),
	// 			getDefectStatisByJobOrderId(job_order_id).then(defectList => {
	// 				data = {...data, ...defectList.reduce((acc, curr)=> {
	// 					acc.Insp_count = acc.Insp_count! + curr.Insp_count!
	// 					acc.bad_count = acc.bad_count! + curr.bad_count!
	// 					acc.total_def_count = acc.total_def_count! + curr.total_def_count!
	// 					acc.total_bad_count = acc.total_bad_count! + curr.total_bad_count!
	// 					return acc
	// 				}, {
	// 					Insp_count: 0,
	// 					bad_count: 0,
	// 					total_def_count: 0,
	// 					total_bad_count: 0
	// 				})}
	// 				if (defectList.length > 0) data.children = defectList
	// 			})
	// 		])
	// 		return data;
	// 	} catch(err) {
	// 		console.log(err);
	// 		return;
	// 	}
	// });
	// var array: any[] = await  Promise.all(requests);
	const array = await getStatusOfJobOrderList(result.data._embedded)
	console.log('in function getJobOrderList local var array is', array)
	return {
		data: array,
		dataCount: result.data._size,
		pageCount: result.data._total_pages,
	}
}
/**
 * 获取工单生产状况。
 * @param pageIndex
 * @param pageSize
 * @param filter
 */
var getJobOrdersAsync = async (pageIndex: number, pageSize: number, jt_id: string) => {
	var queryFilter: any | undefined = undefined
	if (jt_id) {
		queryFilter = {
			jt_id: jt_id,
		}
	}
	var result = await jobOrderRequest.queryPage({
		page: pageIndex,
		pagesize: pageSize,
		filter: queryFilter,
	})

	var jt_ids: string[] = []
	var workshop_ids: string[] = []
	result.data._embedded.forEach((v, i) => {
		jt_ids.push(v.jt_id!)
	})

	var jtInfoList = await jtInfoRequest.queryByIds(jt_ids)
	jtInfoList.forEach((v, i) => {
		workshop_ids.push(v.workshop_id!)
	})

	var jtStatusList = await jtStatusRequest.queryByIds(jt_ids)

	var workshops = await workshopRequest.queryByIds(workshop_ids)

	var array: any[] = []
	//遍历工单。
	for (var i = 0; i < result.data._embedded.length; i++) {
		var item = result.data._embedded[i]

		var data = await getJobOrderStatusAsync2(item, jtInfoList, workshops, jtStatusList)
		array.push(data)
	}

	return {
		data: array,
		dataCount: result.data._size,
		pageCount: result.data._total_pages,
	}
}

/**
 *
 * @param index
 * @param ds
 */
var parseJobOrderDefectStatis = (index: number, ds: defect_statis, productName?: string, jtName?: string): jobOrderDefectStatis => {
	return {
		id: ds._id?.$oid!,
		index: index.toString(),
		productName: productName,
		jtName: jtName,
		workCode: '',
		badCount: ds.bad_count!,
		batchCode: ds.roll_code,
		batchStatus: defectService.getDefectStatusText(ds.status),
		filterStatus: defectService.getFilterStatusText(ds.filter_status),
		inspCount: ds.Insp_count!,
		totalBadCount: ds.total_bad_count!,
		totalDefCount: ds.total_def_count!!,
		totalLength: ds.total_len!,
		target: 'defect_statis',
		filter_time: formatDate(ds.filter_time!),
		beginTime: formatDate(ds.begin_time!),
		endTime: formatDate(ds.end_time!),
		label: ds.label,
		filterTime: formatDate(ds.filter_time!),
	}
}

/**
 * 获取工单批次列表展示数据。
 * @param pageIndex
 * @param pageSize
 * @param filter
 */
var getJobOrderDefectStatisAsync = async (pageIndex: number, pageSize: number, filter: FilterQuery | undefined) => {
	var jobOrderFilter: FilterQuery | undefined = undefined
	var defectStatisList: defect_statis[] = []
	var result: any = {}

	var p1 = productRequest.queryAll()
	var p2 = jtInfoRequest.queryAll()

	const results = await Promise.all([p1, p2])
	const products = results[0]
	const jtList = results[1]

	//工单查询条件：1、机台Id。
	if (filter?.jt_id) {
		if (!jobOrderFilter) {
			jobOrderFilter = {}
		}
		Object.assign(jobOrderFilter, {
			jt_id: filter.jt_id,
		})

		//删除后供批次查询使用。
		delete filter.jt_id
	}

	//工单查询条件：2、时间范围。
	if (filter?.begin_time) {
		if (!jobOrderFilter) {
			jobOrderFilter = {}
		}
		Object.assign(jobOrderFilter, {
			start_time: filter.begin_time,
		})

		delete filter.begin_time
	}

	//查询工单。
	// result = await jobOrderRequest.queryPage({
	// 	page: pageIndex,
	// 	pagesize: pageSize,
	// 	filter: jobOrderFilter,
	// })

	//var job_id_array = result.data._embedded.map(t => t._id.$oid)

	//批次查询条件。
	var defectQueryFilter: any | undefined = {
		//job_order_id: { $in: job_id_array },
	}

	Object.assign(defectQueryFilter, filter)
	if (Object.keys(defectQueryFilter).length === 0) {
		defectQueryFilter = undefined
	}

	//先查询批次。
	defectStatisList = await defectStatisRequest.queryAll(defectQueryFilter)

	// var filter_prop_count = 0
	// for (var a in filter) {
	// 	filter_prop_count++
	// }

	// if (filter_prop_count > 0) {
	// 	console.log('filter_prop_count', filter_prop_count)

	//根据批次查询工单Id。
	//defectStatisList = await defectStatisRequest.queryAll(filter)

	var job_order_id_array = defectStatisList.map(o => o.job_order_id).filter(p => p?.length! > 0)
	job_order_id_array = [...new Set(job_order_id_array)]

	var idObjects = job_order_id_array.map(o => {
		return {
			$oid: o,
		}
	})

	if (job_order_id_array.length > 0) {
		if (!jobOrderFilter) {
			jobOrderFilter = {}
		}
		Object.assign(jobOrderFilter, {
			_id: $in(idObjects),
		})
	}

	console.log('job_order_id_array', job_order_id_array)
	console.log('defectQueryFilter', defectQueryFilter)

	// if (defectStatisList.length == 0) {
	// 	return {
	// 		data: [],
	// 		totalPage: 1,
	// 		totalCount: 0,
	// 	}
	// } else {

	// }

	//如果有批次条件按照批次信息进行查询。
	if (defectQueryFilter && Object.keys(defectQueryFilter).length > 0) {
		//如果批次的查询结果中没有包含任何的工单，直接返回空集合。
		if (job_order_id_array.length == 0) {
			return {
				data: [],
				totalPage: 1,
				totalCount: 0,
			}
		} else {
			//根据工单Id查询工单。
			result = await jobOrderRequest.queryPage({
				page: pageIndex,
				pagesize: pageSize,
				filter: jobOrderFilter,
			})
		}
	} else {
		//
		result = await jobOrderRequest.queryPage({
			page: pageIndex,
			pagesize: pageSize,
			filter: jobOrderFilter,
		})
	}
	//}

	var tempArray: jobOrderDefectStatis[] = []
	//遍历工单。
	for (var i = 0; i < result.data._embedded.length; i++) {
		var job_order = result.data._embedded[i]

		//工单Id。
		var job_order_id = job_order._id?.$oid
		var defectDataList = defectStatisList.filter(t => t.job_order_id == job_order_id)

		//获取产品名称。
		var product = products.find(t => t._id?.$oid == job_order.product_id) ?? {}

		//机台信息。
		var jtInfo = jtList.find(t => t._id?.$oid == job_order.jt_id) ?? {}

		var child: jobOrderDefectStatis[] = []
		var sum_totalBadCount = 0
		var sum_totalDefCount = 0
		var sum_totalLength = 0
		var sum_inspCount = 0
		var sum_badCount = 0

		var index = 0

		//遍历所有批次进行数据统计。
		for (var ds of defectDataList) {
			var obj = parseJobOrderDefectStatis(index + 1, ds, product.name, jtInfo.name)

			child.push(obj)

			sum_totalBadCount += ds.total_bad_count!
			sum_totalDefCount += ds.total_def_count!
			sum_totalLength += ds.total_len!
			sum_inspCount += ds.Insp_count!
			sum_badCount += ds.bad_count!

			index++
		}

		var data: jobOrderDefectStatis = {
			id: job_order._id?.$oid!,
			index: (tempArray.length + 1).toString(),
			productName: product.name,
			jtName: jtInfo.name,
			workCode: job_order.code!,
			batchStatus: '',
			badCount: sum_badCount,
			filterStatus: '',
			inspCount: sum_inspCount,
			totalBadCount: sum_totalBadCount,
			totalDefCount: sum_totalDefCount,
			totalLength: sum_totalLength,
			children: child,
			target: 'job_order',
			filter_time: formatDate(job_order.filter_time!),
			beginTime: formatDate(job_order.start_time!),
			endTime: formatDate(job_order.end_time!),
			label: '',
		}

		tempArray.push(data)
	}

	return {
		data: tempArray,
		totalPage: result.data._total_pages,
		totalCount: result.data._size,
	}
}

/**
 * 获取工单的缺陷统计分布。
 * @param job_order_id
 */
var getJobOrderDefectTypeStatAsync = async (job_order_id: string, loadingCallback?: Function) => {
	//1、获取工单的所有批次统计信息。
	var defectStatisList = await getDefectStatisByJobOrderId(job_order_id)
	//工单Id集合。
	var defectStatis_id_array = defectStatisList.map(t => t._id?.$oid)

	//2、获取所有批次对应的缺陷类型。
	var all_defectTypes: defect_type[] = await defectTypeRequest.queryAll({ roll_id: $in(defectStatis_id_array) }, { display: 1, roll_id: 1, type_index: 1 }, undefined, 1000)

	var stat_item: any = {}

	//遍历批次信息，获取所有的缺陷记录。
	for (var ds of defectStatisList) {
		if (loadingCallback) {
			loadingCallback('正在统计批次：' + ds._id?.$oid)
		}

		//缺陷记录请求。
		var defectRequest = getDefectRequest(ds._id?.$oid!)
		//获取所有的缺陷记录。
		var array: defect_xxx[] = []

		try {
			array = await defectRequest.queryAll(undefined, { type_index: 1 }, undefined, 1000)
		} catch (error) {
			console.error('批次查询出错', error.message)
		}

		//获取所有的缺陷类型。
		var defectTypes = all_defectTypes.filter(t => t.roll_id == ds._id?.$oid)

		for (var v of array) {
			//获取缺陷类型名称。
			var typeName = defectTypes.find(t => t.type_index == v.type_index)?.display
			if (!typeName) continue

			if (typeName in stat_item) {
				stat_item[typeName!] += 1
			} else {
				stat_item[typeName!] = 1
			}
		}
	}

	if (loadingCallback) {
		loadingCallback('')
	}

	return stat_item
}

/**
 * 统计工单的生产状况。
 * @param pageIndex
 * @param pageSize
 * @param filter
 */
const getJobOrderStatusList = async (pageIndex: number, pageSize: number, filter: any | undefined) => {
	var params = {
		page: pageIndex,
		pagesize: pageSize,
	}

	var list: any[] = []

	// var response: any = {}
	// if (filter) {
	// 	//这里的 ISODate 由于是mongodb命令，无法在JS中使用，因此直接采用拼接字符串的方式。
	// 	var temp_array: any[] = []
	// 	temp_array.push(`'jt_id':'${filter.jt_id}'`)
	// 	temp_array.push(`'workshop_id':'${filter.workshop_id}'`)

	// 	if (filter.start_time_start && filter.start_time_end) {
	// 		temp_array.push(`'start_time_start':ISODate("${filter.start_time_start}")`)
	// 		temp_array.push(`'start_time_end':ISODate("${filter.start_time_end}")`)
	// 	} else {
	// 		temp_array.push(`'start_time_start':''`)
	// 		temp_array.push(`'start_time_end':''`)
	// 	}

	// 	params['avars'] = `{${temp_array.join(',')}}`

	// 	response = await (await jobOrderRequest.aggregateQuery('production-status-stat-by-params', params)).data
	// } else {
	// 	response = await (await jobOrderRequest.aggregateQuery('production-status-stat', params)).data
	// }

	const _filter: any = {}
	const jtIdMap = await jtInfoRequest.queryAllToMap()
	const workshopIdMap = await workshopRequest.queryAllToMap()
	const jtStatusList = await jtStatusRequest.queryAll()

	const jtIdToStatusMap = jtStatusList.reduce((acc, curr) => {
		acc[curr.jt_id!] = curr
		return acc
	}, {} as any)

	for (const jt of Object.values(jtIdMap)) {
		;(jt as any).workshop = workshopIdMap[jt.workshop_id!]
		;(jt as any).jt_status = jtIdToStatusMap[jt._id!.$oid]
	}

	if (filter) {
		const { jt_id, workshop_id, start_time_start, start_time_end } = filter
		if (jt_id) {
			_filter.jt_id = jt_id
		} else if (workshop_id) {
			const jtInfoList = Object.values(jtIdMap)
			const jtIds = jtInfoList.filter(jtInfo => jtInfo.workshop_id === workshop_id).map(jtInfo => jtInfo._id?.$oid)
			_filter.jt_id = { $in: jtIds } // 获取该车间全部机台
		}

		if (start_time_start) {
			_filter.begin_time = { $gte: { $date: new Date(start_time_start).valueOf() } }
		}
		if (start_time_end) {
			_filter.begin_time = { $lte: { $date: new Date(start_time_end).valueOf() } }
		}
	}
	// 组装id
	// jt_info 根据 jt_id 连接
	// product 根据 productId 查
	// work_shop_id 从 jt_info 中获取

	// unprocess_serious_defect_size ==> serious_defect roll_id,  process_result = 0

	// adjust_len ==> defect_statis 中根据 job_order_id 筛选 is_adjust = 1 total_len , 各个批次sum

	// real_batch_info_count ==> real_batch_info 中 roll_id = 批次id 的数量 , 各个批次sum

	// badCount ==> defect_statis 的 bad_count, 各个批次sum

	// inspCount ==> defect_statis 的 Insp_count, 各个批次sum

	// completeLen ==> defect_statis 的 total_len, 各个批次sum

	const { data: response } = await jobOrderRequest.queryPage({
		page: pageIndex,
		pagesize: pageSize,
		filter: filter && _filter,
		keys: {
			end_time: 1,
			roll_num: 1,
			total_len: 1,
			roll_len: 1,
			process_index: 1,
			code: 1,
			begin_time: 1,
			status: 1,
			product_id: 1,
			jt_id: 1,
		},
	})
	const { _embedded: _jobOrderList } = response
	const jobOrderList: any[] = _jobOrderList
	const jobOrderIdList = jobOrderList.map(jobOrder => jobOrder._id!.$oid)
	const jobOrderIdMap = jobOrderList.reduce((acc, curr) => {
		const jobOrderId = curr._id!.$oid
		acc[jobOrderId] = curr
		return acc
	}, {} as any)
	const productIdList = jobOrderList.map(jobOrder => jobOrder.product_id!)

	const getProductIdMap = async productIdList => {
		return await productRequest.queryIdMapByIds(productIdList)
	}
	const productIdMap = await getProductIdMap(productIdList)
	for (const jobOrder of jobOrderList) {
		jobOrder.product = productIdMap.get(jobOrder.product_id)
		jobOrder.badCount = 0
		jobOrder.inspCount = 0
		jobOrder.completeLen = 0
		jobOrder.adjust_len = 0
		jobOrder.real_batch_info_count = 0
		jobOrder.unprocess_serious_defect_size = 0

		const jtId = jobOrder.jt_id
		jobOrder.jt_info = jtIdMap[jtId]
		jobOrder.work_shop_id = (jobOrder.jt_info && jobOrder.jt_info.work_shop_id) || ''
	}
	// 查询所有关联批次
	const defectStatisList = await defectStatisRequest.queryAll(
		{
			job_order_id: { $in: jobOrderIdList },
		},
		{
			bad_count: 1,
			Insp_count: 1,
			total_len: 1,
			job_order_id: 1,
			is_adjust: 1,
		}
	)
	const defectStatisIdList = defectStatisList.map(defectStatis => defectStatis._id!.$oid)
	// 计算批次 id 到 job_order_id 映射
	const defectStatisIdToJobOrderId = defectStatisList.reduce((acc, curr) => {
		const job_order_id = curr.job_order_id!
		const id = curr._id!.$oid
		acc[id] = job_order_id
		return acc
	}, {} as any)

	for (const defectStatis of defectStatisList) {
		const jobOrderId = defectStatis.job_order_id!
		const jobOrder = jobOrderIdMap[jobOrderId]
		const { bad_count, Insp_count, total_len } = defectStatis
		if (!jobOrder.badCount) {
			jobOrder.badCount = bad_count || 0
		} else {
			jobOrder.badCount += bad_count || 0
		}
		if (!jobOrder.inspCount) {
			jobOrder.inspCount = Insp_count || 0
		} else {
			jobOrder.inspCount += Insp_count || 0
		}
		if (!jobOrder.completeLen) {
			jobOrder.completeLen = total_len || 0
		} else {
			jobOrder.completeLen += total_len || 0
		}
	}

	// 调机批次
	const adjustDefectStatisList = defectStatisList.filter(defectStatis => defectStatis.is_adjust === 1)
	// 计算 adjust_len
	for (const adjustDefectStatis of adjustDefectStatisList) {
		const jobOrderId = adjustDefectStatis.job_order_id!
		const jobOrder = jobOrderIdMap[jobOrderId]
		if (!jobOrder.adjust_len) {
			jobOrder.adjust_len = adjustDefectStatis.total_len || 0
		} else {
			jobOrder.adjust_len += adjustDefectStatis.total_len || 0
		}
	}
	// 统计 unprocess_serious_defect_size
	// seriousDefectRequest.addPipeline([
	// 	{ $match: { roll_id: { $in: {"$var": "defectStatisIdList"}}, process_result: 0 } },
	// 	{
	// 		$group: {
	// 			_id : "$roll_id",
	// 			count: { $sum: 1 },
	// 		}
	// 	}
	// ], 'roll_serious_defect_count', true);
	const allSliceDefectStatisIdList = sliceArray(defectStatisIdList, 200)
	let rollSeriousDefectCountList: any[] = []
	for (const defectStatisIdListSlice of allSliceDefectStatisIdList) {
		const {
			data: { _embedded },
		} = await seriousDefectRequest.aggregateQuery('roll_serious_defect_count', { avars: { defectStatisIdList: defectStatisIdListSlice } })
		rollSeriousDefectCountList = rollSeriousDefectCountList.concat(_embedded)
	}

	for (const rollSeriousDefectCount of rollSeriousDefectCountList) {
		const roll_id = rollSeriousDefectCount._id
		const jobOrderId = defectStatisIdToJobOrderId[roll_id]
		const jobOrder = jobOrderIdMap[jobOrderId]
		if (!jobOrder.unprocess_serious_defect_size) {
			jobOrder.unprocess_serious_defect_size = rollSeriousDefectCount.count || 0
		} else {
			jobOrder.unprocess_serious_defect_size += rollSeriousDefectCount.count || 0
		}
	}
	// 统计 realBatchInfo
	// realBatchInfoRequest.addPipeline([
	// 	{ $match: { job_order_id: { $in: {"$var": "jobOrderIdList"}  } } },
	// 	{
	// 		$group: {
	// 			_id : "$job_order_id",
	// 			count: { $sum: 1 },
	// 		}
	// 	}
	// ], 'job_order_real_batch_count', true);

	const {
		data: { _embedded: jobOrderRealBatchCountList },
	} = await realBatchInfoRequest.aggregateQuery('job_order_real_batch_count', { avars: { jobOrderIdList } })

	for (const jobOrderRealBatchCount of jobOrderRealBatchCountList) {
		const jobOrderId = defectStatisIdToJobOrderId[jobOrderRealBatchCount._id]
		const jobOrder = jobOrderIdMap[jobOrderId]
		jobOrder.real_batch_info_count = jobOrderRealBatchCount.count
	}

	var _embedded = jobOrderList
	//获取所有工序。
	var process_list = await processInfoRequest.queryAll()

	//工序组。
	var process_group_id_array = Array.from<string>(new Set(_embedded.filter(t => t.product && t.product.process_group_id).map(t => t.product.process_group_id)))
	var process_groups_details = await getProcessGroupDetailsByGroupIdArray(process_group_id_array)

	//遍历工单。
	_embedded.forEach(element => {
		var adjustLength = element.adjust_len

		//缺陷张数。
		var badCount = element.badCount
		//批次张数。
		var defectCount = element.inspCount + element.real_batch_info_count
		//良率= 1 - 缺陷张数 / 批次张数
		var yieldRate = Math.abs(1 - badCount / defectCount!)
		//工序处理
		var process_array: any[] = []
		if (element.product && element.product.process_group_id) {
			var process_group_id = element.product.process_group_id
			//当前工单的工序组详情。
			var pgd = process_groups_details.filter(t => t.process_group_id == process_group_id)

			//获取当前工序组的所有工序。
			for (var pd of pgd) {
				var process_info = process_list.find(t => t._id?.$oid == pd.process_id) // (await processInfoRequest.getDocumentById(pd.process_id!)).data

				var pa: any = {
					...process_info,
					sequence: pd.sequence!,
				}

				process_array.push(pa)
			}
		}

		//对工序进行排序。
		process_array.sort((a, b) => {
			return a.sequence - b.sequence
		})

		//当前工序.
		var element_process_index = parseInt(element.process_index)
		var current_process: string | undefined = ''
		//下一工序。
		var next_process: string | undefined = ''

		if (isNaN(element_process_index)) element_process_index = -1

		if (process_array) {
			if (element_process_index > -1) {
				current_process = process_array[element_process_index].name

				var nextProcessIndex = element_process_index + 1
				if (element.process_index >= process_array.length) {
					next_process = '无'
				} else {
					var nextProcess = process_array[nextProcessIndex]
					if (nextProcess) {
						next_process = nextProcess.name
					}
				}
			}
		}

		var process_str = process_array.map(p => p.name).join(',')

		if (isNaN(yieldRate)) yieldRate = 0

		var jtInfo = element.jt_info

		var obj = {
			_id: element._id,
			adjustLength,
			code: element.code,
			yieldRate: (yieldRate * 100).toFixed(2),
			process_list: process_array,
			process_str: process_str,
			product_name: (element.product && element.product.name) || '',
			jt_status_str: jtService.getJTStatusTextByValue(jtInfo?.jt_status?.status),
			jt_name: jtInfo?.name,
			unprocess_serious_defect_count: element.unprocess_serious_defect_size,
			workshop_name: jtInfo?.workshop?.name,
			next_process: next_process,
			current_process: current_process,
			start_time_str: formatDate(element.begin_time!),
			end_time_str: formatDate(element.end_time!),
		}

		list.push(obj)
	})

	return {
		data: list,
		pageCount: response._total_pages,
		dataCount: response._size,
	}
}

/**
 * 获取工单的缺陷统计。
 * @param job_order_id
 */
var getJobOrderDefectStatisDataAsync = async (job_order_id: string, loadingCallback?: Function) => {
	//1、获取工单的所有批次统计信息。
	var defectStatisList = await getDefectStatisByJobOrderId(job_order_id)

	//获取所有机台信息。
	var jt_list = await jtInfoRequest.queryAll()
	var defectStatis_id_array = defectStatisList.map(t => t._id?.$oid)
	//获取所有批次对应的缺陷类型。
	var all_defectTypes = await defectTypeRequest.queryAll({ roll_id: $in(defectStatis_id_array) }, { display: 1, roll_id: 1, type_index: 1 }, undefined, 1000)

	//var result: any[] = []
	var result_item: Array<any> = new Array<any>()

	//var defects: any[] = []
	//遍历批次信息，获取所有的缺陷记录。
	for (var ds of defectStatisList) {
		if (loadingCallback) {
			loadingCallback('正在统计批次：' + ds._id?.$oid)
		}

		var defectRequest = getDefectRequest(ds._id?.$oid!)
		var jtInfo: jt_info | undefined = {}
		if (ds.jt_id) {
			jtInfo = jt_list.find(t => t._id?.$oid == ds.jt_id)
		}

		//获取所有的缺陷记录。
		var array: defect_xxx[] = []

		try {
			array = await defectRequest.queryAll(undefined, { type_index: 1 }, undefined, 1000)
		} catch (error) {
			console.error('批次查询出错', error.message)
		}

		//获取所有的缺陷类型。
		var defectTypes = all_defectTypes.filter(t => t.roll_id == ds._id?.$oid)
		var stat_item: any = {}
		var stat_item_index = -1
		if (ds.jt_id) {
			//result_item = []
			stat_item_index = result_item.findIndex(t => t != undefined && t.jt_id == ds.jt_id)
			if (stat_item_index > -1) {
				stat_item = result_item[stat_item_index]
			}
		}

		//遍历所有缺陷记录。
		array.forEach(element => {
			//根据：type_index 获取缺陷类型名称。
			var typeName = defectTypes.find(t => t.type_index == element.type_index)?.display

			if (typeName) {
				if (typeName in stat_item) {
					stat_item[typeName] += 1
				} else {
					stat_item[typeName] = 1
				}
			}
		})
		if (stat_item_index > -1) {
			result_item.splice(stat_item_index, 1, stat_item)
		} else {
			stat_item.jt_name = jtInfo?.name ?? '--'
			stat_item.jt_id = ds?.jt_id
			result_item.push(stat_item)
		}
	}

	if (loadingCallback) {
		loadingCallback('')
	}

	console.log(result_item)

	return result_item
}

export default {
	getJobOrdersAsync,
	getJobOrderStatusByIdAsync,
	getJobOrderList,
	getJobOrderDefectStatisDataAsync,
	getJobOrderDefectStatisAsync,
	getJobOrderStatusList,
	getJobOrderStatusText,
	getJobOrderDefectTypeStatAsync,
}
